import { render, staticRenderFns } from "./ShopingList.vue?vue&type=template&id=c5205958&scoped=true"
import script from "./ShopingList.vue?vue&type=script&lang=js"
export * from "./ShopingList.vue?vue&type=script&lang=js"
import style0 from "./ShopingList.vue?vue&type=style&index=0&id=c5205958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5205958",
  null
  
)

export default component.exports